import React, { useContext } from "react";
import { Imóvel } from "smart-imob-types";
import EmpresaContext, { EnviarContato } from "../../context";

interface IDetailsProperty {
  imovel: Imóvel;
  style?: any;
}

const ImovelDetalhes = (props: IDetailsProperty) => {
  const { imovel } = props;
  const context = useContext(EmpresaContext);
  return (
    <div
      className="property-news-single-card border-bottom-yellow pb-3"
      style={props.style}
    >
      <h4>Detalhes</h4>
      <div className="row">
        {!!imovel.tipo && (
          <div className="col-md-3 col-sm-6">
            <div className="single-floor-list media">
              <div className="media-left">
                <i className="fa fa-home" />
              </div>
              <div className="media-body">
                <h6>Tipo de imóvel</h6>
                <p>{imovel.tipo}</p>
              </div>
            </div>
          </div>
        )}
        {(context.exibir_visualizacoes === true ||
          context.exibir_visualizacoes === undefined) &&
          !!imovel.visualizações && (
            <div className="col-md-3 col-sm-6">
              <div className="single-floor-list media">
                <div className="media-left">
                  <i className="fa fa-eye" />
                </div>
                <div className="media-body">
                  <h6>Visualizações</h6>
                  <p>{imovel.visualizações || 0} visualizações</p>
                </div>
              </div>
            </div>
          )}
        {!!imovel.destaque && (
          <div className="col-md-3 col-sm-6">
            <div className="single-floor-list media">
              <div className="media-left">
                <i className="fa fa-star" />
              </div>
              <div className="media-body">
                <h6>Destaque do site!</h6>
              </div>
            </div>
          </div>
        )}
        {!!imovel.suítes && (
          <div className="col-md-3 col-sm-6">
            <div className="single-floor-list media">
              <div className="media-left">
                <i className="fa fa-bath" />
              </div>
              <div className="media-body">
                <h6>Suítes!</h6>
                <p>{imovel.suítes} suítes</p>
              </div>
            </div>
          </div>
        )}
        {/* {!!(
            this.context.exibir_local_imovel === undefined ||
            this.context.exibir_local_imovel === true
          ) &&
            !!(
              imovel.exibir_endereço_no_site === true ||
              imovel.exibir_endereço_no_site === undefined
            ) &&
            !!imovel.número || imovel.rua && ( */}
        {!!(
          imovel.exibir_endereço_no_site ||
          imovel.exibir_endereço_no_site === undefined
        ) &&
          !!(imovel.número || imovel.rua || imovel.complemento) && (
            <div className="col-md-3 col-sm-6">
              <div className="single-floor-list media">
                <div className="media-left">
                  <i className="fa fa-list-ol" />
                </div>
                <div className="media-body">
                  <h6>Rua / Num / Complemento</h6>
                  <p>
                    {imovel.rua}
                    {imovel.rua && imovel.número
                      ? `, ${imovel.número}`
                      : imovel.número
                        ? imovel.número
                        : ""}
                    {(imovel.rua || imovel.número) && imovel.complemento
                      ? `, ${imovel.complemento}`
                      : imovel.complemento
                        ? imovel.complemento
                        : ""}
                  </p>
                </div>
              </div>
            </div>
          )}

        {context.mostrar_campos_personalizados &&
          imovel.campos_personalizados_values.map(campo => (
            <div className="col-md-3 col-sm-6">
              <div className="single-floor-list media">
                <div className="media-left">
                  <i className="fa fa-asterisk" />
                </div>
                <div className="media-body">
                  <h6>{campo.nome}</h6>
                  <p>{campo.value}</p>
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default ImovelDetalhes;
